import { render, staticRenderFns } from "./physioProject.vue?vue&type=template&id=d1fac41e&scoped=true"
import script from "./physioProject.vue?vue&type=script&lang=js"
export * from "./physioProject.vue?vue&type=script&lang=js"
import style0 from "./physioProject.vue?vue&type=style&index=0&id=d1fac41e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fac41e",
  null
  
)

export default component.exports